function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.7806 3.25769C12.5858 3.062 12.2692 3.06132 12.0735 3.25615L7.99843 7.3136L3.9755 3.30727C3.77984 3.11241 3.46326 3.11307 3.2684 3.30873C3.07354 3.5044 3.07419 3.82098 3.26986 4.01584L7.28978 8.01917L3.30152 11.9901C3.10583 12.185 3.10514 12.5016 3.29998 12.6973C3.49482 12.8929 3.8114 12.8936 4.00709 12.6988L7.99836 8.72482L12.0578 12.7675C12.2535 12.9624 12.5701 12.9617 12.7649 12.7661C12.9598 12.5704 12.9591 12.2538 12.7635 12.059L8.707 8.01925L12.7791 3.96479C12.9748 3.76996 12.9755 3.45338 12.7806 3.25769Z"
});
function SvgCloseDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDropdown);
export default __webpack_public_path__ + "static/media/close-dropdown.ee02c91b.svg";
export { ForwardRef as ReactComponent };